'use client';

import { useEntrySearchStore } from '@liquorice/next-search';
import { Responsive3ColGrid } from '../Atoms/Layouts';
import NoResults from '../NoResults';
import Result from './Result';

export default function Results() {
  const results = useEntrySearchStore((s) => s.results);

  if (!results || results.length === 0) {
    return <NoResults />;
  }

  return (
    <Responsive3ColGrid>
      {results.map((result) => (
        <Result key={result.id} id={result.id} />
      ))}
    </Responsive3ColGrid>
  );
}
